/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa mortgage calculator
 *
 */
Intesa.MortgageCalculator = function() {

	/**
	 * Local variables
	 *
	 */
	var mortgage = this;
	var resetString = "-";
	var validPromoResults = true;
	var validStandardResults = true;
	var genericSettings = JSON.parse( $( "#genericSettings" ).val() );
	var regExSeparator = "\\" + genericSettings.separator;
	if( regExSeparator == "\\&nbsp;" ) regExSeparator = "\\ ";
	var regExDecimal = "\\" + genericSettings.decimal;
	if( regExDecimal == "\\&nbsp;" ) regExDecimal = "\\ ";
	this.activeCalculator = null;
	/**
	 * Init component
	 *
	 */
	this.init = function() {

		// check calculator
		if( !$( "section.com16-3" ).length ) return;

		mortgage.setVisibleCalculatorAsActive();
		// change callback
		mortgage.changeCallback();

		// on change borrow amount
		$( document ).on( "change focusin focusout", '*[data-algoritmInput="borrowAmount"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			mortgage.changeCallback();

		} );
		
		$(document).on('keyup', 'input[data-algorithm-input="loanDuration"]', function () {
            var slider = $('.rangeslider.rangeslider--2', mortgage.activeCalculator);
            var index = parseInt(slider.attr('data-slider-index'));
            slider.slider('setValue', $(this).val(), true);
            
            $('*[data-algoritmInput="tenor"]', mortgage.activeCalculator).trigger("change");
		});

		// on change tenor
		$( document ).on( "change", '*[data-algoritmInput="tenor"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			mortgage.changeCallback();

		} );

		// on change salary
		$( document ).on( "click", '*[data-algoritmInput="salary"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			mortgage.changeCallback();

		} );		

		// calculate action
		$( '*[data-algoritmInput="calculateBtn"]' ).click( function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			mortgage.changeCallback();

		} );
		
		// on calculator change
		$( document ).on( 'click', '.com15__filterItem', function() {
			var id = $( this ).attr( 'data-filter' );
			var width = $(window).width();
			var calculatorResolution = "desktop" ;
			if(width < 768){
				var calculatorResolution = "mobile" ;
			}
			var calculator = $( '.com15__filter[data-filter="' + id + '"]' ).find( '[data-calculator='+calculatorResolution+']');
		//	loan['loanpurpose'] = id;
			mortgage.setActiveCalculator( calculator );
			mortgage.changeCallback();
		} );

		// fix slider buttons
		$( document ).on( "click", '.js-btnMinus', function( event ) { $( '*[data-algoritmInput="tenor"]', mortgage.activeCalculator ).trigger( "change" ) } );
		$( document ).on( "click", '.js-btnAdd', function( event ) { $( '*[data-algoritmInput="tenor"]', mortgage.activeCalculator ).trigger( "change" ) } );

		//recalculate on tab change
		$(".com16__tabMenu").click(function(){

			mortgage.fillOutputElements();

		});
		
        $('input[data-algorithm-input="loanDuration"]', mortgage.activeCalculator).attr("data-parsley-min", mortgage.tenor.data( "sliderMin" ));
        $('input[data-algorithm-input="loanDuration"]', mortgage.activeCalculator).attr("data-parsley-max", mortgage.tenor.data( "sliderMax" ) );
        $('input[data-algorithm-input="loanDuration"]', mortgage.activeCalculator).val(mortgage.tenor.val());

	};

	
	
	/**
	 * Set Active Calculator
	 *
	 */
	this.setActiveCalculator = function( calculator ) {

		mortgage.activeCalculator = calculator;

	};
	
	
	/**
	 * Set Visible Calculator As Active
	 *
	 */
	this.setVisibleCalculatorAsActive = function() {
		var width = $(window).width();
		var calculatorResolution = "desktop" ;
		if(width < 768){
			var calculatorResolution = "mobile" ;
		}
		var calculators = $( '[data-calculator='+calculatorResolution+']' );
		var calculatorFound = false;

		calculators.each( function() {

			// set visible calculator as active
			if( $(this).is(":visible") ) {

				mortgage.activeCalculator = $( this );
				calculatorFound = true;

			}

		} );

		// handle no calculator active by default
		if( !calculatorFound ) mortgage.activeCalculator = $( '[data-calculator='+calculatorResolution+']' ).first();

	};
	
	/**
	 * Change input callback
	 * 
	 */
	this.changeCallback = function() {

		// disable basket buttons

		
	    var calculatorNavigation = Intesa.CalculatorNavigation.getInstance(mortgage.activeCalculator);
	    calculatorNavigation.init();
		
		$( "*[data-generate-cookie]").attr( "data-enabled", "false" );

		// get inputs
		mortgage.getInputs();

		// check errors
		if( mortgage.borrowAmount.hasClass( "parsley-error" ) ) return;

		// init output elements
		mortgage.initOutputElements();

		// calculate
		mortgage.calculateMortgage();

		// show results
		mortgage.fillOutputElements();

		// enable basket buttons
		$( "*[data-generate-cookie]" ).removeAttr( "data-enabled" );

	};

	/* --------------------- */

	/**
	 * Calculate mortgage
	 * 
	 */
	this.calculateMortgage = function() {

		// set commons output results
		mortgage.interestRateResultPromo = number_format( mortgage.salaryInterestRateValue, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );
		mortgage.interestRateResultStandard = number_format( mortgage.standardInterestRateValue, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );
		mortgage.tenorResultPromo = mortgage.tenorResultStandard = number_format( mortgage.tenorValue, "0", genericSettings.decimal_number, genericSettings.separator_number );

		// log
		console.log( "---------------------" );
		console.log( "FORMULA" );
		console.log( "---------------------" );

		// calculate the scaled interest rate
		mortgage.scaledInterestRateValuePromo = mortgage.calculateScaledInterestRate( mortgage.salaryInterestRateValue );
		mortgage.scaledInterestRateValueStandard = mortgage.calculateScaledInterestRate( mortgage.standardInterestRateValue );

		// log
		console.log( "Scaled Interest Rate Value Promo: " + mortgage.scaledInterestRateValuePromo + " - " + typeof( mortgage.scaledInterestRateValuePromo ) );
		console.log( "Scaled Interest Rate Value Sandard: " + mortgage.scaledInterestRateValueStandard + " - " + typeof( mortgage.scaledInterestRateValueStandard ) );

		// check kind of pricing
		if( mortgage.borrowAmountValue >= mortgage.borrowAmountMin && mortgage.borrowAmountValue <= mortgage.borrowAmountMax ) {

			// set partial output results
			mortgage.loanAmountResultPromo = mortgage.loanAmountResultStandard = number_format( mortgage.borrowAmountValue, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

			// calculate the monthly installment
			mortgage.monthlyInstallmentValuePromo = mortgage.calculateMonthlyInstallment( mortgage.scaledInterestRateValuePromo );
			mortgage.monthlyInstallmentValueStandard = mortgage.calculateMonthlyInstallment( mortgage.scaledInterestRateValueStandard );

			// log
			console.log( "Monthly Installment Value Promo: " + mortgage.monthlyInstallmentValuePromo + " - " + typeof( mortgage.monthlyInstallmentValuePromo )  );
			console.log( "Monthly Installment Value Standard: " + mortgage.monthlyInstallmentValueStandard + " - " + typeof( mortgage.monthlyInstallmentValueStandard )  );

			// set partial output results
			mortgage.monthlyInstallmentResultPromo = number_format( mortgage.monthlyInstallmentValuePromo, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );
			mortgage.monthlyInstallmentResultStandard = number_format( mortgage.monthlyInstallmentValueStandard, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

			// check monthly valid
			if( !isNaN( mortgage.monthlyInstallmentValuePromo ) ) {

				// calculate amount to repay
				mortgage.amountToRepayValuePromo = mortgage.calculataAmountToRepay( mortgage.monthlyInstallmentValuePromo );
			
				// log
				console.log( "Amount to Repay Value Promo: " + mortgage.amountToRepayValuePromo + " - " + typeof( mortgage.amountToRepayValuePromo ) );
				
				// set partial output results
				mortgage.amountToRepayResultPromo = number_format( mortgage.amountToRepayValuePromo, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

				// check amount to repay valid
				if( !isNaN( mortgage.amountToRepayValuePromo ) ) {
					
					// calculate APR
					mortgage.APRValuePromo = mortgage.calculateAPR( mortgage.monthlyInstallmentValuePromo, mortgage.salaryInterestRateValue ) * 100;

					// log
					console.log( "APR Value Promo: " + mortgage.APRValuePromo + " - " + typeof( mortgage.APRValuePromo ) );

					// set partial output results
					mortgage.APRResultPromo = number_format( mortgage.APRValuePromo, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );

					// check APR valid
					if( isNaN( mortgage.APRValuePromo ) ) validPromoResults = false;

				} else {

					validPromoResults = false;

				}

			} else {
			
				validPromoResults = false;

			}

			// check monthly valid
			if( !isNaN( mortgage.monthlyInstallmentValueStandard ) ) {

				// calculate amount to repay
				mortgage.amountToRepayValueStandard = mortgage.calculataAmountToRepay( mortgage.monthlyInstallmentValueStandard );

				// log
				console.log( "Amount to Repay Value Standard: " + mortgage.amountToRepayValueStandard + " - " + typeof( mortgage.amountToRepayValueStandard ) );

				// set partial output results
				mortgage.amountToRepayResultStandard = number_format( mortgage.amountToRepayValueStandard, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

				// check amount to repay valid
				if( !isNaN( mortgage.amountToRepayValueStandard ) ) {

					// calculate APR
					mortgage.APRValueStandard = mortgage.calculateAPR( mortgage.monthlyInstallmentValueStandard, mortgage.standardInterestRateValue ) * 100;

					// log
					console.log( "APR Value Standard: " + mortgage.APRValueStandard + " - " + typeof( mortgage.APRValueStandard ) );

					// set partial output results
					mortgage.APRResultStandard = number_format( mortgage.APRValueStandard, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );

					// check APR valid
					if( isNaN( mortgage.APRValueStandard ) ) validStandardResults = false;

				} else {
					
					validStandardResults = false;

				}

			} else {
			
				validStandardResults = false;

			}

		} else {

			validPromoResults = validStandardResults = false;

		}

	};

	/**
	 * Calculate Scaled Interest Rate
	 * 
	 * @param {*} interestRate 
	 */
	this.calculateScaledInterestRate = function( interestRate ) {

		return Number( ( interestRate / 100 ) * ( ( 365 / 360 ) / 12 ) );

	};

	/**
	 * Calculate Monthly Installment
	 * 
	 * @param {*} scaledInterestRate 
	 */
	this.calculateMonthlyInstallment = function( scaledInterestRate ) {

		return Number( Math.round( ( mortgage.borrowAmountValue * scaledInterestRate ) / ( 1 - ( 1 / Math.pow( ( 1 + scaledInterestRate ), 12 * mortgage.tenorValue ) ) ) ) );

	};

	/**
	 * Calculate Amount to Repay
	 * 
	 * @param {*} monthlyInstallment 
	 */
	this.calculataAmountToRepay = function( monthlyInstallment ) {

		return Number( 12 * ( monthlyInstallment + mortgage.regularFeeValue ) * mortgage.tenorValue + mortgage.startFeeValue + mortgage.closingFeeValue );

	};

	/**
	 * Calculate APR
	 * 
	 * @param {*} monthlyInstallment 
	 * @param {*} interestRate 
	 */
	this.calculateAPR = function( monthlyInstallment, interestRate ) {

		return Number( round( ( Math.pow( 1 + mortgage.getIRR( mortgage.getCashFlow( monthlyInstallment ), 0.0001 ) , 12 ) - 1 ), 4 ) );
		
	};

	/* --------------------- */

	/**
	 * Init output elements
	 * 
	 */
	this.initOutputElements = function() {

		mortgage.setOutputElements();
		mortgage.resetOutputElements();

	};

	/**
	 * Set output elements
	 * 
	 */
	this.setOutputElements = function() {

		// promo
		mortgage.monthlyInstallmentPromo = $( '*[data-algoritmResult="monthlyInstallmentPromo"]', mortgage.activeCalculator );
		mortgage.loanAmountPromo = $( '*[data-algoritmResult="loanAmountPromo"]', mortgage.activeCalculator );
		mortgage.amountToRepayPromo = $( '*[data-algoritmResult="amountToRepayPromo"]' , mortgage.activeCalculator);
		mortgage.tenorPromo = $( '*[data-algoritmResult="tenorPromo"]' , mortgage.activeCalculator);
		mortgage.interestRatePromo = $( '*[data-algoritmResult="interestRatePromo"]' , mortgage.activeCalculator);
		mortgage.aprPromo = $( '*[data-algoritmResult="aprPromo"]', mortgage.activeCalculator );

		// standard
		mortgage.monthlyInstallmentStandard = $( '*[data-algoritmResult="monthlyInstallmentStandard"]' , mortgage.activeCalculator);
		mortgage.loanAmountStandard = $( '*[data-algoritmResult="loanAmountStandard"]', mortgage.activeCalculator );
		mortgage.amountToRepayStandard = $( '*[data-algoritmResult="amountToRepayStandard"]' , mortgage.activeCalculator);
		mortgage.tenorStandard = $( '*[data-algoritmResult="tenorStandard"]', mortgage.activeCalculator );
		mortgage.interestRateStandard = $( '*[data-algoritmResult="interestRateStandard"]' , mortgage.activeCalculator);
		mortgage.aprStandard = $( '*[data-algoritmResult="aprStandard"]', mortgage.activeCalculator );

	};

	/**
	 * Reset output elements
	 * 
	 */
	this.resetOutputElements = function() {

		mortgage.resetPromoOutputElements();
		mortgage.resetStandardOutputElements();

	};

	/**
	 * Reset promo output elements
	 * 
	 */
	this.resetPromoOutputElements = function() {

		validPromoResults = true;

		mortgage.monthlyInstallmentResultPromo = undefined;
		mortgage.loanAmountResultPromo = undefined;
		mortgage.amountToRepayResultPromo = undefined;
		mortgage.tenorResultPromo = undefined;
		mortgage.interestRateResultPromo = undefined;
		mortgage.APRResultPromo = undefined;

		mortgage.monthlyInstallmentPromo.text( resetString );
		mortgage.loanAmountPromo.text( resetString );
		mortgage.amountToRepayPromo.text( resetString );
		mortgage.tenorPromo.text( resetString );
		mortgage.interestRatePromo.text( resetString );
		mortgage.aprPromo.text( resetString );

	};

	/**
	 * Reset standard output elements
	 * 
	 */
	this.resetStandardOutputElements = function() {

		validStandardResults = true;

		mortgage.monthlyInstallmentResultStandard = undefined;
		mortgage.loanAmountResultStandard = undefined;
		mortgage.amountToRepayResultStandard = undefined;
		mortgage.tenorResultStandard = undefined;
		mortgage.interestRateResultStandard = undefined;
		mortgage.APRResultStandard = undefined;

		mortgage.monthlyInstallmentStandard.text( resetString );
		mortgage.loanAmountStandard.text( resetString );
		mortgage.amountToRepayStandard.text( resetString );
		mortgage.tenorStandard.text( resetString );
		mortgage.interestRateStandard.text( resetString );
		mortgage.aprStandard.text( resetString );

	};

	/* --------------------- */

	/**
	 * Fill output elements
	 * 
	 */
	this.fillOutputElements = function() {

		mortgage.fillPromoOutputElements();
		mortgage.fillStandardOutputElements();

	};

	/**
	 * Fill promo output elements
	 * 
	 */
	this.fillPromoOutputElements = function() {

		if( validPromoResults ) {

			mortgage.interestRatePromo.text( mortgage.interestRateResultPromo );
			mortgage.aprPromo.text( mortgage.APRResultPromo );
			mortgage.loanAmountPromo.text( mortgage.loanAmountResultPromo );
			mortgage.tenorPromo.text( mortgage.tenorResultPromo );
			mortgage.monthlyInstallmentPromo.text( mortgage.monthlyInstallmentResultPromo );
			mortgage.amountToRepayPromo.text( mortgage.amountToRepayResultPromo );

		} else mortgage.resetPromoOutputElements();
 
		var cmbInput = $( "*[data-cmb-input]" );

		if( cmbInput.length ) {
			
			var loanConfigurationBasketJSON = '{"LOANAMOUNT":"' + mortgage.loanAmountResultPromo.replace( /\s/g, "" ) + '","DURATION":"' + mortgage.tenorResultPromo + '","INSTALLMENT":"' + mortgage.monthlyInstallmentResultPromo.replace( /\s/g, "" ) + '","DISCOUNTCODE":"' + mortgage.salaryInterestRateCode.toString() + '","APR":"' + mortgage.APRResultPromo.replace( ",", "." ) + '","INTERESTRATE":"' + mortgage.interestRateResultPromo.replace( ",", "." ) + '"}';
			
			if( $( '[data-active-tab="with-salary"]', mortgage.activeCalculator ).hasClass( "open" ) ) {

				// update the input of call me back
				cmbInput.val( loanConfigurationBasketJSON );
	
			}

		}	

	};

	/**
	 * Fill standard output elements
	 * 
	 */
	this.fillStandardOutputElements = function() {

		// show results
		if( validStandardResults ) {

			mortgage.interestRateStandard.text( mortgage.interestRateResultStandard );
			mortgage.aprStandard.text( mortgage.APRResultStandard );
			mortgage.loanAmountStandard.text( mortgage.loanAmountResultStandard );
			mortgage.tenorStandard.text( mortgage.tenorResultStandard );
			mortgage.monthlyInstallmentStandard.text( mortgage.monthlyInstallmentResultStandard );
			mortgage.amountToRepayStandard.text( mortgage.amountToRepayResultStandard );

		} else mortgage.resetStandardOutputElements();

		var cmbInput = $( "*[data-cmb-input]" );

		if( cmbInput.length ) {
			
			var loanConfigurationBasketJSON = '{"LOANAMOUNT":"' + mortgage.loanAmountResultStandard.replace( /\s/g, "" ) + '","DURATION":"' + mortgage.tenorResultStandard + '","INSTALLMENT":"' + mortgage.monthlyInstallmentResultStandard.replace( /\s/g, "" ) + '","DISCOUNTCODE":"' + mortgage.salaryInterestRateCode.toString() + '","APR":"' + mortgage.APRResultStandard.replace( ",", "." ) + '","INTERESTRATE":"' + mortgage.interestRateResultStandard.replace( ",", "." ) + '"}';
			
			if(!$('[data-active-tab="withsalary"]').hasClass("open")){

				// update the input of call me back
				cmbInput.val( loanConfigurationBasketJSON );
	
			} 			

		}		

	};

	/* --------------------- */

	/**
	 * Get inputs
	 * 
	 */
	this.getInputs = function() {

		// log
		console.log( "---------------------" );
		console.log( "CALCULATOR INPUTS" );
		console.log( "---------------------" );

		// fee
		mortgage.startFee = $( '*[data-algoritmInput="startFee"]' , mortgage.activeCalculator);
		mortgage.startFeeValue = Number( parseFloat( ( mortgage.startFee.val() == "" ) ? 0 : mortgage.startFee.val() ) );
		mortgage.regularFee = $( '*[data-algoritmInput="regularFee"]', mortgage.activeCalculator );
		mortgage.regularFeeValue = Number( parseFloat( ( mortgage.regularFee.val() == "" ) ? 0 : mortgage.regularFee.val() ) );
		mortgage.closingFee = $( '*[data-algoritmInput="closingFee"]' , mortgage.activeCalculator);
		mortgage.closingFeeValue = Number( parseFloat( ( mortgage.closingFee.val() == "" ) ? 0 : mortgage.closingFee.val() ) );
		
		// log
		console.log( "Start Fee Value: " + mortgage.startFeeValue + " - " + typeof( mortgage.startFeeValue ) );
		console.log( "Regular Fee Value: " + mortgage.regularFeeValue + " - " + typeof( mortgage.regularFeeValue ) );
		console.log( "Closing Fee Value: " + mortgage.closingFeeValue + " - " + typeof( mortgage.closingFeeValue ) );

		// borrow
		mortgage.borrowAmount = $( '*[data-algoritmInput="borrowAmount"]', mortgage.activeCalculator );
		mortgage.borrowAmountValue = Number( parseFloat( mortgage.borrowAmount.val().replace( new RegExp( regExSeparator, 'g' ), "" ).replace( new RegExp( regExDecimal, 'g' ), "." ) ) );
		mortgage.borrowAmountMin = Number( parseFloat( mortgage.borrowAmount.data( "inputMin" ) ) );
		mortgage.borrowAmountMax = Number( parseFloat( mortgage.borrowAmount.data( "inputMax" ) ) );

		// log
		console.log( "Borrow Amount Value: " + mortgage.borrowAmountValue + " - " + typeof( mortgage.borrowAmountValue ) );
		console.log( "Borrow Amount Min Value: " + mortgage.borrowAmountMin + " - " + typeof( mortgage.borrowAmountMin ) );
		console.log( "Borrow Amount Max Value: " + mortgage.borrowAmountMax + " - " + typeof( mortgage.borrowAmountMax ) );

		// tenor
		mortgage.tenor = $( '*[data-algoritmInput="tenor"]', mortgage.activeCalculator );
		mortgage.tenorValue = Number( mortgage.tenor.val() );
		mortgage.tenorMin = Number( mortgage.tenor.data( "sliderMin" ) );
		mortgage.tenorMax = Number( mortgage.tenor.data( "sliderMax" ) );
		mortgage.tenorStep = Number( mortgage.tenor.data( "sliderStep" ) );


		// log
		console.log( "Tenor Value: " + mortgage.tenorValue + " - " + typeof( mortgage.tenorValue ) );
		console.log( "Tenor Min Value: " + mortgage.tenorMin + " - " + typeof( mortgage.tenorMin ) );
		console.log( "Tenor Max Value: " + mortgage.tenorMax + " - " + typeof( mortgage.tenorMax ) );
		console.log( "Tenor Step Value: " + mortgage.tenorStep + " - " + typeof( mortgage.tenorStep ) );

		// init temp variables
		var standardTenorRangeChecked = false;
		var standardInterestRateTmp = 0;
		
		// standard interest rate
		mortgage.standardInterestRate = $( '*[data-algoritmInput="standardInterestRate"]' , mortgage.activeCalculator).data( "salaryRate" );
		if( mortgage.standardInterestRate.interestSettings.length ) {

			for( var index = 0; index < mortgage.standardInterestRate.interestSettings.length; index ++ ) {

				if( !standardTenorRangeChecked && 
					mortgage.tenorValue >= mortgage.standardInterestRate.interestSettings[ index ].minimumTenor && 
					mortgage.tenorValue <= mortgage.standardInterestRate.interestSettings[ index ].maximumTenor ) {

					standardTenorRangeChecked = true;
					standardInterestRateTmp = mortgage.standardInterestRate.interestSettings[ index ].interestRate;

				}

			}

		}
		mortgage.standardInterestRate = standardInterestRateTmp;
		mortgage.standardInterestRateValue = Number( parseFloat( mortgage.standardInterestRate ) );

		// log
		console.log( "Standard Interest Rate Value: " + mortgage.standardInterestRateValue + " - " + typeof( mortgage.standardInterestRateValue ) );

		// init temp variables
		var salaryTenorRangeChecked = false;
		var salaryInterestRateTmp = mortgage.standardInterestRate;

		// salary rate
		mortgage.salaryInterestRate = $( '*[data-algoritmInput="salary"].active', mortgage.activeCalculator ).data( "salaryRate" );
		if( mortgage.salaryInterestRate.interestSettings.length ) {

			for( var index = 0; index < mortgage.salaryInterestRate.interestSettings.length; index ++ ) {

				if( !salaryTenorRangeChecked && 
					mortgage.tenorValue >= mortgage.salaryInterestRate.interestSettings[ index ].minimumTenor && 
					mortgage.tenorValue <= mortgage.salaryInterestRate.interestSettings[ index ].maximumTenor ) {

					salaryInterestRateTmp = true;
					salaryInterestRateTmp = mortgage.salaryInterestRate.interestSettings[ index ].interestRate;

				}

			}

		} 
		mortgage.salaryInterestRate = salaryInterestRateTmp;
		mortgage.salaryInterestRateValue = Number( parseFloat( mortgage.salaryInterestRate ) );
		mortgage.salaryInterestRateCode = $( '*[data-algoritmInput="salary"].active', mortgage.activeCalculator ).data( "salaryCode" );

		// log
		console.log( "Salary Interest Rate Value: " + mortgage.salaryInterestRateValue + " - " + typeof( mortgage.salaryInterestRateValue ) );
		console.log( "Salary Interest Rate Code: " + mortgage.salaryInterestRateCode + " - " + typeof( mortgage.salaryInterestRateCode ) );
	};

	/**
	 * IRR calculate
	 * 
	 * @param {*} values 
	 * @param {*} guess 
	 */
	this.getIRR = function( values, guess ) {
	
		if( !isFinite( guess ) ) { return NaN; }
		
		var used_guess = guess;
		var x, next_x;
		
		if( used_guess === -1.0 ) { x = 0.1; }
		else { x = used_guess; }
		
		var max_iterations = 30;
		var iterations_done = 0;
		var wanted_precision = 0.00000001;
		var current_diff = Number.MAX_VALUE;
		var current, above, below, index;
		
		while( current_diff > wanted_precision && iterations_done < max_iterations ) {
			
			index = 0;
			above = 0.0;
			below = 0.0;
			
			for( var ii = 0; ii <= ( values.length - 1 ); ii++ ) {
				
				current = values[ ii ];
				above += current / Math.pow( 1.0 + x, index );
				below += -index * current / Math.pow( 1.0 + x, index + 1.0 );
				index++;
			
			}
			
			next_x = x - above / below;
			iterations_done++;
			current_diff = Math.abs( next_x - x );
			x = next_x;
		
		}
		
		if( used_guess === 0.0 && Math.abs( x ) < wanted_precision ) { x = 0.0; }
		if( current_diff < wanted_precision ) { return x; }
		else { return NaN; }
	
	};

	/**
	 * Get cash flow
	 * 
	 */
	this.getCashFlow = function( monthlyInstallment ) {

		var cashFlow = [ mortgage.startFeeValue - mortgage.borrowAmountValue ];

		for( var index = 0; index < ( ( mortgage.tenorValue * 12 ) - 1 ); index++ ) {

			cashFlow.push( monthlyInstallment + mortgage.regularFeeValue );

		}

		cashFlow.push( monthlyInstallment + mortgage.regularFeeValue + mortgage.closingFeeValue );

		return cashFlow;

	};

};

/**
 * Get class instance
 *
 */
Intesa.MortgageCalculator.getInstance = function() {
	
	if( !window.intesa ) {
		
		window.intesa = new Object();
		
	}
	if( !window.intesa.mortgage_calculator ) {
		
		window.intesa.mortgage_calculator = new Intesa.MortgageCalculator();
		
	}
	
	return window.intesa.mortgage_calculator;

};
